var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-sumo-container",style:({background: 'url(' + require('../../assets/img/illustrations/mountain-saturized-op5.png') + '), #ffffff', })},[_c('dealify-header',{staticClass:"mb-4"}),_c('dealify-form',{staticClass:"m-0 m-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }